export default __webpack_public_path__ + "static/media/naturalgas.4d76996b.svg";